import { Controller } from "@hotwired/stimulus";
import { dsConfirm } from "../../utils/ds_confirm";

export default class extends Controller {
  static targets = ["quantity", "unitPrice", "total", "row"];

  connect() {
    this.calculateTotal();
  }

  calculate() {
    this.calculateTotal();

    // Notifier le contrôleur parent que cet élément a changé
    const event = new CustomEvent("item-changed", {
      bubbles: true,
      detail: { id: this.element.dataset.id },
    });
    this.element.dispatchEvent(event);
  }

  calculateTotal() {
    const quantity = parseFloat(this.quantityTarget.value) || 0;
    const unitPrice = parseFloat(this.unitPriceTarget.value) || 0;

    // Calcul du total avec remise
    const total = quantity * unitPrice;

    // Mise à jour de l'affichage du total
    this.totalTarget.textContent = this.formatCurrency(total);

    const evt = new CustomEvent("purchase_order_item:updateTotalOrder", {
      bubbles: true,
      detail: {},
    });
    this.element.dispatchEvent(evt);

    return total;
  }

  getItemTotal() {
    const quantity = parseFloat(this.quantityTarget.value) || 0;
    const unitPrice = parseFloat(this.unitPriceTarget.value) || 0;

    return quantity * unitPrice;
  }

  updateQuantity(event) {
    this.calculate();
  }

  updatePrice(event) {
    this.calculate();
  }

  async removeItem(event) {
    event.preventDefault();

    if (await dsConfirm("Êtes-vous sûr de vouloir supprimer cet élément ?", { tone: "danger" })) {
      // Supprimer la ligne du tableau
      this.rowTarget.remove();

      // Notifier le contrôleur parent qu'un élément a été supprimé
      const event = new CustomEvent("item-removed", {
        bubbles: true,
        detail: { id: this.element.dataset.id },
      });
      this.element.dispatchEvent(event);
    }
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "XAF",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  }
}
